module.exports = __webpack_public_path__ + "img/phone.b9e9fe28.png";